import React from 'react';
import './Controls.less';
import {ButtonIcon} from '@homeaway/react-buttons';
import {CHEVRON_LEFT__16, CHEVRON_RIGHT__16} from '@homeaway/svg-defs';

import classNames from 'classnames';

// eslint-disable-next-line complexity
function Controls(props) {
    const {
        isMobile,
        className,
        enabled,
        numMonths,
        i18n,
        mobileBehavior
    } = props;

    const dataWdio = props.wdioPrefix
        ? `${props.wdioPrefix}-calendar-controls`
        : 'calendar-controls';

    const isMobilePagingAffiliates =
        isMobile &&
        enabled &&
        (mobileBehavior === 'single-affiliates' ||
            mobileBehavior === 'double-affiliates');
    const isMobileSingleMonth =
        isMobile &&
        enabled &&
        (mobileBehavior === 'single' || mobileBehavior === 'single-affiliates');
    const isMobileMultiMonth =
        isMobile && enabled && mobileBehavior === 'double-affiliates';
    const isDesktopSingleMonth = !isMobile && numMonths === 1;
    const isDesktopMultiMonth = !isMobile && numMonths > 1;

    const rootClasses = classNames('cal-controls', 'clearfix', className, {
        'cal-controls--mobile-paging-affiliates': isMobilePagingAffiliates,
        'cal-controls--mobile-paging-single-affiliates':
            isMobilePagingAffiliates && mobileBehavior === 'single-affiliates'
    });

    const parentClasses = classNames('', {
        'cal-controls__calendar-parent--top-single': isMobileSingleMonth,
        'cal-controls__calendar-parent--middle-single': isDesktopSingleMonth,
        'cal-controls__calendar-parent--middle-multi': isDesktopMultiMonth
    });

    const buttonClasses = classNames('cal-controls__button', 'text-center', {
        'cal-controls__button--top': isMobileSingleMonth || isMobileMultiMonth,
        'cal-controls__button--top-multi': isMobileMultiMonth,
        'cal-controls__button--middle':
            isDesktopSingleMonth || isDesktopMultiMonth,
        'cal-controls__button--single-affiliates':
            isMobilePagingAffiliates && mobileBehavior === 'single-affiliates',
        'cal-controls__button--double-affiliates':
            isMobilePagingAffiliates && mobileBehavior === 'double-affiliates'
    });

    const prevButtonClasses = classNames(
        buttonClasses,
        'cal-controls__button--prev',
        {
            'cal-controls__button--affiliates-prev': isMobilePagingAffiliates
        }
    );

    const nextButtonClasses = classNames(
        buttonClasses,
        'cal-controls__button--next',
        {
            'cal-controls__button--affiliates-next': isMobilePagingAffiliates
        }
    );

    if (enabled) {
        return (
            <div
                role="application"
                className={rootClasses}
                data-wdio={dataWdio}
            >
                <div className={prevButtonClasses}>
                    <ButtonIcon
                        label={i18n.ariaLabelPrevButton}
                        circle
                        svgMarkup={CHEVRON_LEFT__16}
                        size="sm"
                        className="btn-hover-zoom"
                        onClick={props.onPrevClicked}
                        disabled={!props.canRetreat}
                    />
                </div>
                <div className={`${parentClasses || ''}`}>{props.children}</div>
                <div className={nextButtonClasses}>
                    <ButtonIcon
                        label={i18n.ariaLabelNextButton}
                        circle
                        svgMarkup={CHEVRON_RIGHT__16}
                        size="sm"
                        className="btn-hover-zoom"
                        onClick={props.onNextClicked}
                        disabled={!props.canAdvance}
                    />
                </div>
            </div>
        );
    }

    return (
        <div
            className={`${className || ''} cal-controls--empty`}
            data-wdio={dataWdio}
        >
            {props.children}
        </div>
    );
}

export default Controls;
